import { useQuery } from "@tanstack/react-query";
import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { getActivityIdNotesV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useActivityNotesQuery = (id: number) => {
	return useQuery({
		queryKey: ActivityKeys.detailNotes(id),
		queryFn: processResponse(() => getActivityIdNotesV2(id)),
		enabled: id !== 0,
	});
};
